// hooks/useUser.ts
import { useGetUserQuery } from '../graphql/generated/graphql'

export function useUser() {
  const { data, loading, error, refetch } = useGetUserQuery()
  
  return {
    user: data?.user,
    subscription: data?.user?.subscription,
    usage: data?.user?.usage,
    loading,
    error,
    refetch,
  }
}

// Helper hooks for specific data
export function useSubscription() {
  const { subscription, loading } = useUser()
  return { subscription, loading }
}

export function useUsage() {
  const { usage, loading } = useUser()
  return { usage, loading }
}